import { dockDoorStatusColor } from "../../util/helper/helperFunctions";

const Pallet = ({ status, className }) => (
  <div
    style={{
      backgroundColor: dockDoorStatusColor(status),
    }}
    className={className}
  >
    s
  </div>
);

export default Pallet;
